import $ from 'jquery';
import screenSize from '../services/screen_size';
import config from '../config';
class MobileBottomSocialBar {
    constructor() {
        this.$window = $(window);
        this.scopedResizeListener = this.resizeListener.bind(this);
        this.scopedMobileScroll = this.mobileScroll.bind(this);
        this.show = this.show.bind(this);
        this.lastY = window.scrollY;
        this.activeClass = 'active';
    }

    mobileScroll() {
        if (config.get('featureFlags.postInfiniteScroll')) {
            if (this.getDirection()) {
                this.$nav.addClass(this.activeClass);
                this.$mobileSocialBar.addClass(this.activeClass);
            }
            return this;
        }

        if (
            this.topOffset < this.$window.scrollTop() &&
            this.bottomOffset > this.$window.scrollTop() &&
            this.getDirection()
        ) {
            this.$nav.addClass(this.activeClass);
            this.$mobileSocialBar.addClass(this.activeClass);
        } else {
            if (config.get('featureFlags.postInfiniteScroll') === true) {
                return;
            }
            this.$nav.removeClass(this.activeClass);
            this.$mobileSocialBar.removeClass(this.activeClass);
        }
        return this;
    }

    getDirection() {
        var currentY = window.scrollY;

        if (currentY > this.lastY) {
            this.lastY = currentY;
            this.$window.trigger('fc:scroll:up');
            return true;
        } else if (currentY < this.lastY) {
            this.lastY = currentY;
            this.$window.trigger('fc:scroll:down');
            return false;
        }
    }

    scrollListener() {
        if (screenSize.getSize() === 'small') {
            this.$window.on('scroll', this.scopedMobileScroll);
            return this;
        }
        this.off();
        return this;
    }

    resizeListener() {
        return this
            .off()
            .on();
    }

    on() {
        this.$nav = $('.navbar-brands-container');
        this.$shareButtons = $('.post-share-buttons');
        this.$mobileSocialBar = $('.mobile-bottom-social-bar');

        if (this.$shareButtons && this.$shareButtons.first() && this.$shareButtons.first().offset()) {
            this.topOffset = this.$shareButtons.first().offset().top;
            this.bottomOffset = this.$shareButtons.last().offset().top - this.$window.height();
            this.$window.on('resize', this.scopedResizeListener);
            this.$window.on('fc:show:mobile:bottom:socialbar', this.show);
            this.$window.on('fc:hide:mobile:bottom:socialbar', this.hide);
            return this.scrollListener();
        }
    }

    off() {
        this.$window.off('scroll', this.scopedMobileScroll);
        this.$window.off('resize', this.scopedResizeListener);
        this.$window.off('fc:show:mobile:bottom:socialbar', this.show);
        this.$window.off('fc:hide:mobile:bottom:socialbar', this.hide);
        return this;
    }

    show() {
        this.$nav.addClass(this.activeClass);
        this.$mobileSocialBar.addClass(this.activeClass);
    }

    hide() {
        this.$nav.removeClass(this.activeClass);
        this.$mobileSocialBar.removeClass(this.activeClass);
    }
}

export default new MobileBottomSocialBar();
